import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IDatePickerWrapperProps extends IBaseProps {
  isRange?: boolean;
  label: string;
}

const DatePickerWrapper: React.FC<IDatePickerWrapperProps> = (props) => {
  const { style, className, isRange = false, label, children } = props;

  return (
    <div style={style} className={classnames('dbg-date-picker-wrapper', className, { 'is-range-picker': isRange })}>
      <div className="dbg-date-picker-wrapper__label">{label}</div>
      <div className="dbg-date-picker-wrapper__context">{children}</div>
    </div>
  );
};

export default DatePickerWrapper;
